// Wrapper component that shows desktop or mobile version based on screen size
import BrowseTimetablesDesktop from './BrowseTimetablesDesktop';
import BrowseTimetablesMobile from './BrowseTimetablesMobile';

/**
 * BrowseTimetables Wrapper
 * 
 * Desktop version: Full desktop layout with integrated nav and sidebar
 * Mobile version: Mobile-optimized layout with bottom navigation
 */
export default function BrowseTimetables() {
  return (
    <>
      {/* Desktop version - hidden on mobile/tablet */}
      <div className="hidden lg:block">
        <BrowseTimetablesDesktop />
      </div>
      
      {/* Mobile version - hidden on desktop */}
      <div className="lg:hidden">
        <BrowseTimetablesMobile />
      </div>
    </>
  );
}
